
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "./firebase-config";

export class Repo {

  public async getDailyTrafficData() {
    const docRef = doc(db, "traffic", "daily");
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return docSnap.data();
    } else {
      console.log("No such document!");
    }
  }

  public async markObservationReviewed(observation: any) {

    const docRef = doc(db, "observationReviews", observation.id);
    console.log(observation);
    const data = {
      id: observation.id,
      childId: observation.childId,
      childIds: observation.childId.split(",").map((x: any) => x.trim()),
      reviewed: !observation.reviewed,
      visibleToParents: observation.visibleToParents || false,
    };

    await setDoc(docRef, data);
  };

  public async markObservationVisibleToParents(observation: any) {
    const docRef = doc(db, "observationReviews", observation.id);
    console.log(observation);
    const data = {
      id: observation.id,
      childId: observation.childId,
      childIds: observation.childId.split(",").map((x: any) => x.trim()),
      reviewed: observation.reviewed || false,
      visibleToParents: !observation.visibleToParents,
    };
    await setDoc(docRef, data);
  };

  public async deleteObservation(observation: any) {
    const docRef = doc(db, "observationReviews", observation.id);
    console.log(observation);
    const data = {
      id: observation.id,
      childId: observation.childId,
      childIds: observation.childId.split(",").map((x: any) => x.trim()),
      reviewed: observation.reviewed || false,
      visibleToParents: observation.visibleToParents || false,
      ignore: true,
    };

    await setDoc(docRef, data);

  };

  public async resaveAllObservationReviews(filteredObservations: any[]) {

    for (const observation of filteredObservations) {

      const docRef = doc(db, "observationReviews", observation.id);
      console.log(observation);
      const data = {
        id: observation.id,
        childId: observation.childId,
        childIds: observation.childId.split(",").map((x: any) => x.trim()),
        reviewed: observation.reviewed || false,
        visibleToParents: observation.visibleToParents || false,
      };

      await setDoc(docRef, data);
    }
  }

  public async markAccidentReviewed(accident: any) {

    const docRef = doc(db, "accidentReviews", accident.id);
    console.log(accident);
    const data = {
      id: accident.id,
      childId: accident.childId,
      reviewed: !accident.reviewed,
      visibleToParents: accident.visibleToParents || false,
    };

    await setDoc(docRef, data);
  };

  public async markAccidentVisibleToParents(accident: any) {
    const docRef = doc(db, "accidentReviews", accident.id);
    const data = {
      id: accident.id,
      childId: accident.childId,
      reviewed: accident.reviewed || false,
      visibleToParents: !accident.visibleToParents,
    };

    await setDoc(docRef, data);
  };
}